export const AppPageLayouts = {
  SwipeableBottomPane: "SwipeableBottomPane",
  PanelGroupHorizontal: "PanelGroupHorizontal",
  PanelGroupVertical: "PanelGroupVertical",
} as const;

export type AppPageLayout =
  (typeof AppPageLayouts)[keyof typeof AppPageLayouts];
